import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './RichTextEditor.css';

// Barra strumenti: titoli, grassetto/corsivo, citazione, blocco codice, elenchi, link.
const modules = {
  toolbar: [
    [{ header: [2, 3, false] }],
    ['bold', 'italic', 'underline'],
    ['blockquote', 'code-block'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link'],
    ['clean'],
  ],
};

const formats = [
  'header', 'bold', 'italic', 'underline',
  'blockquote', 'code-block', 'list', 'bullet', 'link',
];

// Editor di testo ricco (WYSIWYG). value/onChange lavorano su una stringa HTML.
function RichTextEditor({ value, onChange, placeholder }) {
  return (
    <div className="rich-text">
      <ReactQuill
        theme="snow"
        value={value || ''}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
      />
    </div>
  );
}

// True se l'HTML non contiene testo/immagini reali (es. "<p><br></p>" di Quill vuoto).
export function htmlVuoto(html) {
  if (!html) return true;
  const senzaTag = html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
  return senzaTag === '' && !/<img|<iframe/i.test(html);
}

export default RichTextEditor;
